import React, { useState } from 'react';
import './Navbar.css'
import { Link } from 'react-router-dom'
import logoicon from '../../assest/Profile Icon.png'

const Navbar = () => {
   const [isOpen, setIsOpen] = useState(false);
    const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
    <div className='navbar'>
      <div className='navbar1'>
             <Link to={"/"}><h1>ExamSify</h1></Link> 
               <div className="hamburger" onClick={toggleMenu}>
          {isOpen ? '✖' : '☰'}
        </div>
              <div className='navbar2'>
                <ul>
            <Link to={"/submit-request"}>   <li>Submit Request</li></Link> 
               <Link to={"/contact"}>  <li>Contact</li> </Link>
               <Link to={"/ai-solution"}  > <li className='ai-border'>AI Student Analysis</li></Link>
             <Link to={"/login"}> <img src={logoicon}/></Link> 
                   </ul>
              </div>
      </div>
    </div>
      
    </>
  )
}

export default Navbar
